// extracted by mini-css-extract-plugin
export var animationContainer = "_o8-0";
export var footer = "_o8-1";
export var gray = "_o8-2";
export var lineItem = "_o8-3";
export var lineItemImage = "_o8-4";
export var lineItemInfo = "_o8-5";
export var lineItemText = "_o8-6";
export var lineItems = "_o8-7";
export var modalContent = "_o8-8";
export var options = "_o8-9";
export var orderName = "_o8-a";
export var refundAmount = "_o8-b";